import { proxy } from 'valtio';

const state = proxy<{
    sorting: 'newest' | 'oldest' | 'latest-activity';
    filters: {
        resolved: boolean;
        deleted: boolean;
    };
}>({
    sorting: 'latest-activity',
    filters: {
        resolved: false,
        deleted: false,
    },
});

export { state };
